module.exports = __webpack_public_path__ + "img/0Q3B9939-45_P_D_Source.d6177df0.webp";